<template>
  <div id="app">
    <AppHeader />
    <div class="app-main">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'

export default {
  name: 'App',
  components: {
    AppHeader
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  background: #0a0e27;
  color: #e2e8f0;
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0d1229 100%);
  position: relative;
  overflow-x: hidden;
}

#app::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.04) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(99, 102, 241, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(139, 92, 246, 0.02) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

.app-main {
  flex: 1;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
  border-radius: 4px;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.5);
}

/* Element UI 全局样式覆盖 */
.el-message {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  min-width: 300px !important;
}

.el-message__content {
  color: #e2e8f0 !important;
  font-size: 14px !important;
}

.el-message__icon {
  font-size: 16px !important;
}

/* Success - 绿色 */
.el-message.el-message--success .el-message__icon {
  color: #22c55e !important;
}

.el-message.el-message--success .el-message__icon svg {
  stroke: #22c55e !important;
  fill: none !important;
}

.el-message.el-message--success .el-message__icon svg path,
.el-message.el-message--success .el-message__icon svg circle,
.el-message.el-message--success .el-message__icon svg polyline {
  stroke: #22c55e !important;
}

/* Error - 红色 */
.el-message.el-message--error .el-message__icon {
  color: #ef4444 !important;
}

.el-message.el-message--error .el-message__icon svg {
  stroke: #ef4444 !important;
  fill: none !important;
}

.el-message.el-message--error .el-message__icon svg path,
.el-message.el-message--error .el-message__icon svg circle,
.el-message.el-message--error .el-message__icon svg polyline {
  stroke: #ef4444 !important;
}

/* Warning - 黄色 */
.el-message.el-message--warning .el-message__icon {
  color: #fbbf24 !important;
}

.el-message.el-message--warning .el-message__icon svg {
  stroke: #fbbf24 !important;
  fill: none !important;
}

.el-message.el-message--warning .el-message__icon svg path,
.el-message.el-message--warning .el-message__icon svg circle,
.el-message.el-message--warning .el-message__icon svg polyline {
  stroke: #fbbf24 !important;
}

/* Info - 紫色 */
.el-message.el-message--info .el-message__icon {
  color: #6366f1 !important;
}

.el-message.el-message--info .el-message__icon svg {
  stroke: #6366f1 !important;
  fill: none !important;
}

.el-message.el-message--info .el-message__icon svg path,
.el-message.el-message--info .el-message__icon svg circle,
.el-message.el-message--info .el-message__icon svg polyline {
  stroke: #6366f1 !important;
}

.el-message-box {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
  border-radius: 16px !important;
}

.el-message-box__header {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  padding: 20px 20px 16px !important;
}

.el-message-box__title {
  color: #e2e8f0 !important;
}

.el-message-box__content {
  color: #94a3b8 !important;
  padding: 20px !important;
}

.el-message-box__btns {
  padding: 12px 20px 20px !important;
}

.el-button--primary {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  border: none !important;
  color: #fff !important;
}

.el-button--default {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #cbd5e1 !important;
}

/* Loading 遮罩 */
.el-loading-mask {
  background: rgba(10, 14, 39, 0.8) !important;
  backdrop-filter: blur(4px);
}

.el-loading-spinner .circular {
  stroke: #6366f1;
}

/* 日期选择器暗色主题 - 全局覆盖 */
.el-picker-panel {
  background: rgba(15, 23, 42, 0.98) !important;
  border: 1px solid rgba(99, 102, 241, 0.3) !important;
  backdrop-filter: blur(20px) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
  color: #e2e8f0 !important;
}

.el-picker-panel *,
.el-picker-panel *::before,
.el-picker-panel *::after {
  box-sizing: border-box;
}

.el-picker-panel__body-wrapper,
.el-picker-panel__body,
.el-picker-panel__content {
  background: transparent !important;
}

/* 日期范围选择器面板 */
.el-date-range-picker {
  background: rgba(15, 23, 42, 0.98) !important;
  border: 1px solid rgba(99, 102, 241, 0.3) !important;
}

.el-date-range-picker__content {
  background: transparent !important;
}

.el-date-range-picker__header {
  background: transparent !important;
  color: #e2e8f0 !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.15) !important;
}

.el-date-range-picker__header button {
  color: #94a3b8 !important;
  background: transparent !important;
}

.el-date-range-picker__header button:hover {
  color: #a5b4fc !important;
}

.el-date-range-picker__header .el-date-picker__header-label {
  color: #e2e8f0 !important;
}

.el-date-range-picker__header .el-date-picker__header-label:hover {
  color: #a5b4fc !important;
}

/* 日期表格 */
.el-date-table {
  background: transparent !important;
}

.el-date-table th {
  background: transparent !important;
  color: #94a3b8 !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.15) !important;
}

.el-date-table td {
  color: #e2e8f0 !important;
}

.el-date-table td .el-date-table-cell {
  color: #e2e8f0 !important;
}

.el-date-table td .el-date-table-cell__text {
  color: #e2e8f0 !important;
}

.el-date-table td.today .el-date-table-cell__text {
  color: #6366f1 !important;
  font-weight: 600;
}

.el-date-table td.available:hover .el-date-table-cell__text {
  background: rgba(99, 102, 241, 0.15) !important;
  color: #a5b4fc !important;
}

.el-date-table td.in-range .el-date-table-cell__text {
  background: rgba(99, 102, 241, 0.15) !important;
}

.el-date-table td.start-date .el-date-table-cell__text,
.el-date-table td.end-date .el-date-table-cell__text {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-date-table td.current:not(.disabled) .el-date-table-cell__text {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-date-table td.disabled .el-date-table-cell__text {
  color: #475569 !important;
  background: transparent !important;
}

.el-date-table td.next-month .el-date-table-cell__text,
.el-date-table td.prev-month .el-date-table-cell__text {
  color: #475569 !important;
}

/* 月份和年份选择器 */
.el-month-table td .cell,
.el-year-table td .cell {
  color: #e2e8f0 !important;
}

.el-month-table td .cell:hover,
.el-year-table td .cell:hover {
  background: rgba(99, 102, 241, 0.15) !important;
  color: #a5b4fc !important;
}

.el-month-table td.in-range .cell {
  background: rgba(99, 102, 241, 0.15) !important;
}

.el-month-table td.start-date .cell,
.el-month-table td.end-date .cell {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-month-table td.current:not(.disabled) .cell,
.el-year-table td.current:not(.disabled) .cell {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

/* 侧边栏和快捷选项 */
.el-picker-panel__sidebar {
  background: rgba(15, 23, 42, 0.8) !important;
  border-right: 1px solid rgba(99, 102, 241, 0.15) !important;
}

.el-picker-panel__shortcut {
  color: #94a3b8 !important;
  background: transparent !important;
}

.el-picker-panel__shortcut:hover {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}

/* 底部按钮区域 */
.el-picker-panel__footer {
  background: rgba(15, 23, 42, 0.8) !important;
  border-top: 1px solid rgba(99, 102, 241, 0.15) !important;
}

.el-picker-panel__link-btn {
  color: #94a3b8 !important;
  background: transparent !important;
}

.el-picker-panel__link-btn:hover {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}

/* 确认按钮 */
.el-picker-panel__link-btn.is-confirm {
  color: #6366f1 !important;
}

/* 时间选择器头部 */
.el-date-range-picker__time-header {
  background: transparent !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.15) !important;
}

.el-date-range-picker__time-picker-wrap {
  background: rgba(15, 23, 42, 0.5) !important;
  border: 1px solid rgba(99, 102, 241, 0.15) !important;
}

.el-date-range-picker__editor {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  color: #e2e8f0 !important;
}

.el-date-range-picker__editor:hover {
  border-color: rgba(99, 102, 241, 0.4) !important;
}

.el-date-range-picker__editor:focus {
  border-color: #6366f1 !important;
  outline: none !important;
}

/* 日期选择器输入框 */
.el-date-editor .el-input__wrapper,
.el-date-editor .el-input__inner,
.el-date-picker .el-input__wrapper,
.el-date-picker .el-input__inner,
.el-range-editor .el-input__wrapper,
.el-range-editor .el-input__inner {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  box-shadow: none !important;
  color: #e2e8f0 !important;
}

.el-date-editor .el-input__wrapper:hover,
.el-date-editor .el-input__inner:hover,
.el-date-picker .el-input__wrapper:hover,
.el-date-picker .el-input__inner:hover {
  border-color: rgba(99, 102, 241, 0.4) !important;
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.15) !important;
}

.el-date-editor .el-input__wrapper.is-focus,
.el-date-editor .el-input__inner:focus,
.el-date-picker .el-input__wrapper.is-focus,
.el-date-picker .el-input__inner:focus {
  border-color: #6366f1 !important;
  box-shadow: 0 0 16px rgba(99, 102, 241, 0.25) !important;
}

.el-date-editor .el-input__prefix,
.el-date-editor .el-input__icon,
.el-date-picker .el-input__prefix,
.el-date-picker .el-input__icon {
  color: rgba(99, 102, 241, 0.6) !important;
}

/* 下拉选择器暗色主题 */
.el-select-dropdown {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
}

.el-select-dropdown__item {
  color: #e2e8f0 !important;
}

.el-select-dropdown__item:hover {
  background: rgba(99, 102, 241, 0.15) !important;
  color: #a5b4fc !important;
}

.el-select-dropdown__item.selected {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}

.el-select-dropdown__item.is-disabled {
  color: #475569 !important;
}

/* 下拉选择器输入框 */
.el-select .el-input__wrapper {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  box-shadow: none !important;
}

.el-select .el-input__wrapper:hover {
  border-color: rgba(99, 102, 241, 0.4) !important;
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.15) !important;
}

.el-select .el-input__wrapper.is-focus {
  border-color: #6366f1 !important;
  box-shadow: 0 0 16px rgba(99, 102, 241, 0.25) !important;
}

.el-select .el-input__inner {
  color: #e2e8f0 !important;
}

.el-select .el-input__prefix {
  color: rgba(99, 102, 241, 0.6) !important;
}

.el-select .el-input__suffix {
  color: rgba(99, 102, 241, 0.6) !important;
}

/* 日期范围选择器面板完整样式 */
.el-date-range-picker {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
}

.el-date-range-picker.has-sidebar {
  background: rgba(15, 23, 42, 0.95) !important;
}

.el-date-range-picker__header {
  background: transparent !important;
  color: #e2e8f0 !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.1) !important;
}

.el-date-range-picker__header .el-date-picker__header-label {
  color: #e2e8f0 !important;
}

.el-date-range-picker__header .el-date-picker__header-label:hover {
  color: #a5b4fc !important;
}

.el-date-range-picker__header button {
  color: #94a3b8 !important;
}

.el-date-range-picker__header button:hover {
  color: #a5b4fc !important;
}

.el-date-range-picker__header button:not(.disabled):hover {
  color: #a5b4fc !important;
}

.el-date-range-picker__header button.disabled {
  color: #475569 !important;
}

.el-date-range-picker__content {
  background: transparent !important;
  padding: 8px 12px !important;
}

.el-date-range-picker__time-header {
  background: transparent !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.1) !important;
  padding: 8px 12px !important;
}

.el-date-range-picker__time-picker-wrap {
  background: transparent !important;
  border: 1px solid rgba(99, 102, 241, 0.1) !important;
}

.el-date-range-picker__editor {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  color: #e2e8f0 !important;
}

.el-date-range-picker__editor:hover {
  border-color: rgba(99, 102, 241, 0.4) !important;
}

.el-date-range-picker__editor:focus {
  border-color: #6366f1 !important;
  outline: none !important;
}

.el-picker-panel__footer {
  background: rgba(15, 23, 42, 0.8) !important;
  border-top: 1px solid rgba(99, 102, 241, 0.1) !important;
  padding: 8px 16px !important;
}

.el-picker-panel__link-btn {
  color: #94a3b8 !important;
  background: transparent !important;
}

.el-picker-panel__link-btn:hover {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}

.el-picker-panel__body {
  background: transparent !important;
}

.el-picker-panel__body-wrapper {
  background: transparent !important;
}

/* Popper 容器样式（日期选择器的外层容器） */
.el-picker-panel.el-popper {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
}

/* 弹出层通用样式 */
.el-popper {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: rgba(99, 102, 241, 0.2) !important;
}

.el-popper[x-placement^="top"] .popper__arrow {
  border-top-color: rgba(99, 102, 241, 0.2) !important;
}

.el-popper .popper__arrow::after {
  border-bottom-color: rgba(15, 23, 42, 0.95) !important;
}

/* 日期表格单元格 */
.el-date-table td {
  color: #e2e8f0 !important;
}

.el-date-table td .el-date-table-cell__text {
  color: #e2e8f0 !important;
}

.el-date-table td.in-range .el-date-table-cell__text {
  background: rgba(99, 102, 241, 0.1) !important;
}

.el-date-table td.start-date .el-date-table-cell__text,
.el-date-table td.end-date .el-date-table-cell__text {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-date-table td.today .el-date-table-cell__text {
  color: #6366f1 !important;
  font-weight: 600;
}

.el-date-table td.available:hover .el-date-table-cell__text {
  background: rgba(99, 102, 241, 0.1) !important;
  color: #a5b4fc !important;
}

.el-date-table td.current:not(.disabled) .el-date-table-cell__text {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-date-table td.disabled .el-date-table-cell__text {
  color: #475569 !important;
  background: transparent !important;
}

.el-date-table td.next-month .el-date-table-cell__text,
.el-date-table td.prev-month .el-date-table-cell__text {
  color: #475569 !important;
}

/* 星期标题 */
.el-date-table th {
  background: transparent !important;
  color: #94a3b8 !important;
  border-bottom: 1px solid rgba(99, 102, 241, 0.1) !important;
}

/* 年月选择表格 */
.el-month-table td .cell {
  color: #e2e8f0 !important;
}

.el-month-table td .cell:hover {
  background: rgba(99, 102, 241, 0.1) !important;
  color: #a5b4fc !important;
}

.el-month-table td.in-range .cell {
  background: rgba(99, 102, 241, 0.1) !important;
}

.el-month-table td.start-date .cell,
.el-month-table td.end-date .cell {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-month-table td.current:not(.disabled) .cell {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

.el-year-table td .cell {
  color: #e2e8f0 !important;
}

.el-year-table td .cell:hover {
  background: rgba(99, 102, 241, 0.1) !important;
  color: #a5b4fc !important;
}

.el-year-table td.current:not(.disabled) .cell {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #fff !important;
}

/* 确保 el-dialog 可以交互 */
.el-dialog__wrapper {
  pointer-events: auto !important;
}

.el-dialog {
  pointer-events: auto !important;
}

.el-dialog__header,
.el-dialog__body,
.el-dialog__footer {
  pointer-events: auto !important;
}

/* 确保遮罩层不会阻止交互 */
.v-modal {
  pointer-events: auto !important;
}
</style>
